import {AppRouter} from "./Routes/AppRouter";
import "./font/Gilroy/font.css";
function App() {
    return (
        <AppRouter/>
    );
}

export default App;